"use strict";

var _classCallCheck = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ParamNames_1 = require("../../enum/ParamNames");

var ParseError_1 = require("../../errors/ParseError");

var Params_1 = require("../../utils/Params");

var AbstractBodyNode_1 = require("./AbstractBodyNode");

var AbstractAssign =
/*#__PURE__*/
function (_AbstractBodyNode_1$d) {
  _inherits(AbstractAssign, _AbstractBodyNode_1$d);

  function AbstractAssign() {
    _classCallCheck(this, AbstractAssign);

    return _possibleConstructorReturn(this, _getPrototypeOf(AbstractAssign).apply(this, arguments));
  }

  _createClass(AbstractAssign, [{
    key: "checkParams",
    value: function checkParams(token) {
      var params = Params_1.paramParser(token.start, token.end, token.params);

      if (params) {
        var result = [];

        if (params.type === ParamNames_1.default.Compound) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = params.body[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var param = _step.value;
              result.push(this.isAssignmentExpression(param, token));
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          result.push(this.isAssignmentExpressionSingle(params, token));
        }

        return result;
      }

      throw new ParseError_1.default("".concat(this.type, " require params"), token);
    }
  }, {
    key: "isAssignmentExpressionSingle",
    value: function isAssignmentExpressionSingle(param, token) {
      return this.isAssignmentExpression(param, token);
    }
  }, {
    key: "isAssignmentExpression",
    value: function isAssignmentExpression(param, token) {
      if (param.type === ParamNames_1.default.AssignmentExpression) {
        return param;
      }

      throw new ParseError_1.default("Invalid parameters in ".concat(this.type), token);
    }
  }]);

  return AbstractAssign;
}(AbstractBodyNode_1.default);

exports.default = AbstractAssign;